module.exports = __webpack_public_path__ + "static/media/playBtnWhite.90224b88.svg";